import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { Switch as SwitchPrimitive } from 'radix-ui';

import { Label } from './label.jsx';

const switchVariants = cva(
  'group/switch peer inline-flex cursor-pointer items-center rounded-2xl border border-transparent-main p-[3px] focus:outline-2 focus:outline-action-focusBorder disabled:pointer-events-none disabled:border-border-disabled disabled:bg-border-disabled data-[state=checked]:bg-primary-main disabled:data-[state=checked]:bg-action-disabledBackground data-[state=unchecked]:bg-ui-inverse01 disabled:data-[state=unchecked]:bg-action-disabledBackground',
  {
    variants: {
      size: {
        small: 'h-4 w-8',
        medium: 'h-6 w-12',
      },
    },
    defaultVariants: {
      size: 'medium',
    },
  },
);

function Switch({
  className,
  size = 'medium',
  disabled,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> &
  VariantProps<typeof switchVariants>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(switchVariants({ size }), className)}
      data-size={size}
      disabled={disabled}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        data-size={size}
        className={cn(
          'block rounded-full transition-transform peer-disabled:pointer-events-none data-[size=medium]:size-4.5 data-[size=small]:size-2.5 data-[state=checked]:translate-x-[calc(100%+6px)] data-[state=checked]:bg-icon-inverse group-disabled/switch:data-[state=checked]:bg-action-disabled01 data-[state=unchecked]:translate-x-0 data-[state=unchecked]:bg-ui-tertiary group-disabled/switch:data-[state=unchecked]:bg-action-disabled01',
        )}
      />
    </SwitchPrimitive.Root>
  );
}

function SwitchLabel({
  className,
  ...props
}: React.ComponentProps<typeof Label>) {
  return (
    <Label
      variant="bodyShort01"
      className={cn(className, 'inline-flex items-center gap-2')}
      {...props}
    />
  );
}

export { Switch, SwitchLabel };
